export const REGISTER_USER = 'REGISTER_USER';
export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS';
export const REGISTER_USER_FAILURE = 'REGISTER_USER_FAILURE';

export const COMPLETE_REGISTRATION = 'COMPLETE_REGISTRATION';
export const COMPLETE_REGISTRATION_SUCCESS = 'COMPLETE_REGISTRATION_SUCCESS';
export const COMPLETE_REGISTRATION_FAILURE = 'COMPLETE_REGISTRATION_FAILURE';

export const POLL_EMAIL_VERIFICATION = 'POLL_EMAIL_VERIFICATION';
export const POLL_EMAIL_VERIFICATION_SUCCESS = 'POLL_EMAIL_VERIFICATION_SUCCESS';
export const POLL_EMAIL_VERIFICATION_FAILURE = 'POLL_EMAIL_VERIFICATION_FAILURE';
export const STOP_POLL_EMAIL_VERIFICATION = 'STOP_POLL_EMAIL_VERIFICATION';

export const RESEND_EMAIL_VERIFICATION = 'RESEND_EMAIL_VERIFICATION';
export const RESEND_EMAIL_VERIFICATION_SUCCESS = 'RESEND_EMAIL_VERIFICATION_SUCCESS';
export const RESEND_EMAIL_VERIFICATION_FAILURE = 'RESEND_EMAIL_VERIFICATION_FAILURE';
export const RESEND_EMAIL_COOLDOWN_TICK = 'RESEND_EMAIL_COOLDOWN_TICK';
export const RESEND_EMAIL_COOLDOWN_EXPIRE = 'RESEND_EMAIL_COOLDOWN_EXPIRE';

export const FETCH_PROFILE_FOR_COMPLETE_REGISTRATION = 'FETCH_PROFILE_FOR_COMPLETE_REGISTRATION';
export const FETCH_PROFILE_FOR_COMPLETE_REGISTRATION_SUCCESS = 'FETCH_PROFILE_FOR_COMPLETE_REGISTRATION_SUCCESS';
export const FETCH_PROFILE_FOR_COMPLETE_REGISTRATION_FAILURE = 'FETCH_PROFILE_FOR_COMPLETE_REGISTRATION_FAILURE';

export const INIT_COMPLETE_REGISTRATION = 'INIT_COMPLETE_REGISTRATION';

export const FETCH_ADDRESSES = 'FETCH_ADDRESSES';
export const FETCH_ADDRESSES_SUCCESS = 'FETCH_ADDRESSES_SUCCESS';
export const FETCH_ADDRESSES_FAILURE = 'FETCH_ADDRESSES_FAILURE';

export const SELECT_ADDRESS = 'SELECT_ADDRESS';
export const SELECT_ADDRESS_SUCCESS = 'SELECT_ADDRESS_SUCCESS';
export const SELECT_ADDRESS_FAILURE = 'SELECT_ADDRESS_FAILURE';
export const RESET_AUTOCOMPLETE = 'RESET_AUTOCOMPLETE';

export const FETCH_ADDRESSES_MIGRATE = 'FETCH_ADDRESSES_MIGRATE';
export const FETCH_ADDRESSES_MIGRATE_SUCCESS = 'FETCH_ADDRESSES_MIGRATE_SUCCESS';
export const FETCH_ADDRESSES_MIGRATE_FAILURE = 'FETCH_ADDRESSES_MIGRATE_FAILURE';

export const SELECT_ADDRESS_MIGRATE = 'SELECT_ADDRESS_MIGRATE';
export const SELECT_ADDRESS_MIGRATE_SUCCESS = 'SELECT_ADDRESS_MIGRATE_SUCCESS';
export const SELECT_ADDRESS_MIGRATE_FAILURE = 'SELECT_ADDRESS_MIGRATE_FAILURE';
export const RESET_AUTOCOMPLETE_MIGRATE = 'RESET_AUTOCOMPLETE_MIGRATE';


export const LOGIN_USER = 'LOGIN_USER';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_FAILURE = 'LOGIN_USER_FAILURE';

export const GET_FORGOT_PASSWORD_CODE = 'GET_FORGOT_PASSWORD_CODE';
export const GET_FORGOT_PASSWORD_CODE_SUCCESS = 'GET_FORGOT_PASSWORD_CODE_SUCCESS';
export const GET_FORGOT_PASSWORD_CODE_FAILURE = 'GET_FORGOT_PASSWORD_CODE_FAILURE';

export const CONFIRM_RESET_PASSWORD = 'CONFIRM_RESET_PASSWORD';
export const CONFIRM_RESET_PASSWORD_SUCCESS = 'CONFIRM_RESET_PASSWORD_SUCCESS';
export const CONFIRM_RESET_PASSWORD_FAILURE = 'CONFIRM_RESET_PASSWORD_FAILURE';

export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const UPDATE_PROFILE_SUCCESS = 'UPDATE_PROFILE_SUCCESS';
export const UPDATE_PROFILE_FAILURE = 'UPDATE_PROFILE_FAILURE';

export const VERIFY_EMAIL = 'VERIFY_EMAIL';
export const VERIFY_EMAIL_SUCCESS = 'VERIFY_EMAIL_SUCCESS';
export const VERIFY_EMAIL_FAILURE = 'VERIFY_EMAIL_FAILURE';
export const CONTINUE_AFTER_EMAIL_VERIFICATION = 'CONTINUE_AFTER_EMAIL_VERIFICATION';

export const FETCH_PROFILE = 'FETCH_PROFILE';
export const FETCH_PROFILE_SUCCESS = 'FETCH_PROFILE_SUCCESS';
export const FETCH_PROFILE_FAILURE = 'FETCH_PROFILE_FAILURE';

export const NYL_SSO_ACCESS_TOKEN = 'NYL_SSO_ACCESS_TOKEN';
export const NYL_SSO_REFRESH_TOKEN = 'NYL_SSO_REFRESH_TOKEN';
export const NYL_SSO_IDENTITY_TOKEN = 'NYL_SSO_IDENTITY_TOKEN';
export const NYL_SSO_IDENTITY = 'NYL_SSO_IDENTITY';
export const NYL_SSO_EXPIRES_IN = 'NYL_SSO_EXPIRES_IN';
export const NYL_SSO_FIRST_NAME = 'NYL_SSO_FIRST_NAME';
export const NYL_SSO_LAST_NAME = 'NYL_SSO_LAST_NAME';
export const NYL_SSO_CLIENT_ID = 'NYL_SSO_CLIENT_ID';
export const NYL_SSO_CALLBACK_URI = 'NYL_SSO_CALLBACK_URI';

export const MIGRATE_PROFILE = 'MIGRATE_PROFILE';
export const MIGRATE_PROFILE_SUCCESS = 'MIGRATE_PROFILE_SUCCESS';
export const MIGRATE_PROFILE_FAILURE = 'MIGRATE_PROFILE_FAILURE';

export const SAVE_USER_PROFILE = 'SAVE_USER_PROFILE';

export const FETCH_GOV_ID_RESPONSE = 'FETCH_GOV_ID_RESPONSE';
export const FETCH_GOV_ID_RESPONSE_SUCCESS = 'FETCH_GOV_ID_RESPONSE_SUCCESS';
export const FETCH_GOV_ID_RESPONSE_FAILURE = 'FETCH_GOV_ID_RESPONSE_FAILURE';
export const GET_GOV_ID_LINK = 'GET_GOV_ID_LINK';
export const GET_GOV_ID_LINK_SUCCESS = 'GET_GOV_ID_LINK_SUCCESS';
export const GET_GOV_ID_LINK_FAILURE = 'GET_GOV_ID_LINK_FAILURE';
export const GET_PREFILL_HINT = 'GET_PREFILL_HINT';
export const GET_PREFILL_HINT_SUCCESS = 'GET_PREFILL_HINT_SUCCESS';
export const GET_PREFILL_HINT_FAILURE = 'GET_PREFILL_HINT_FAILURE';

export const SIGN_OUT = 'SIGN_OUT';
export const SIGN_OUT_SUCCESS = 'SIGN_OUT_SUCCESS';
export const SIGN_OUT_FAILURE = 'SIGN_OUT_FAILURE';
